export type SelectOption = {
  title: string;
  value: string;
};

export enum ScreenOrientations {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export type SelectExtendedOption = SelectOption & {
  checked: boolean;
};

export const defaultSelectOption = {
  title: 'All',
  value: '',
} as SelectOption;
